export const THUMBNAIL_PLACEHOLDER =
  "https://evodream.nyc3.cdn.digitaloceanspaces.com/thumbs/exercice-placeholder-black.png";

export const THUMBNAIL_PLACEHOLDER_GRAY =
  "https://evodream.nyc3.cdn.digitaloceanspaces.com/thumbs/program-placeholder-gray.png";

export const NUTRITION_PROGRAM_PLACEHOLDER =
  "https://evocoach.nyc3.cdn.digitaloceanspaces.com/thumbs/nutrition/nutrition_placeholder_image.png";

export const NUTRITION_RECIPE_PLACEHOLDER =
  "https://evocoach.nyc3.cdn.digitaloceanspaces.com/thumbs/nutrition/nutrition_recipe_placeholder_image.png";

export const ROUTES_WITH_PROMPT_WARNING = [
  "/fitness/exercices/new",
  "/fitness/exercices/:id",
  "/fitness/sessions/create",
  "/fitness/sessions/:id",
  "/fitness/sessions/final",
  "/fitness/sessions/final/:id",
  "/fitness/programs/:id",
  "/fitness/programs/final",
  "/fitness/programs/final/:id",
  "/nutrition/recipes/create",
  "/nutrition/recipes/:id",
  "/nutrition/programs/create",
  "/nutrition/programs/:id",
  "/nutrition/programs/final",
  "/nutrition/programs/final/:id",
];

export const ATTENTION_MESSAGE =
  "Vous êtes sur le point de quitter cette page. Si vous avez effectué des modifications, assurez-vous de les avoir sauvegardées avant de continuer.";
